class HeaderMore extends HTMLElement {
  constructor() {
    super();
    this.onDocClick = this.onDocClick.bind(this);
    this.onKeydown = this.onKeydown.bind(this);
    this.onFocusOut = this.onFocusOut.bind(this);
    this.closeTimer = null;
  }

  connectedCallback() {
    this.button = this.querySelector('.header-more__button');
    this.panel = this.querySelector('.header-more__panel');
    if (!this.button || !this.panel) return;

    // hover opens it like the other header dropdowns; click only opens so a touch tap doesn't open then close
    this.button.addEventListener('click', () => this.open());
    this.addEventListener('mouseenter', () => {
      clearTimeout(this.closeTimer);
      this.open();
    });
    this.addEventListener('mouseleave', () => {
      this.closeTimer = setTimeout(() => this.close(), 100);
    });
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('focusout', this.onFocusOut);
    document.addEventListener('click', this.onDocClick);
  }

  disconnectedCallback() {
    clearTimeout(this.closeTimer);
    document.removeEventListener('click', this.onDocClick);
  }

  get isOpen() {
    return this.button.getAttribute('aria-expanded') === 'true';
  }

  get links() {
    return Array.from(this.panel.querySelectorAll('a'));
  }

  open() {
    this.panel.hidden = false;
    this.button.setAttribute('aria-expanded', 'true');
  }

  close(returnFocus = false) {
    this.panel.hidden = true;
    this.button.setAttribute('aria-expanded', 'false');
    if (returnFocus) this.button.focus();
  }

  onDocClick(event) {
    if (this.isOpen && !this.contains(event.target)) this.close();
  }

  onFocusOut(event) {
    // close when focus tabs out of the menu
    if (this.isOpen && event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
  }

  onKeydown(event) {
    const links = this.links;
    const index = links.indexOf(document.activeElement);

    if (event.key === 'Escape' && this.isOpen) {
      event.preventDefault();
      this.close(true);
    } else if (event.key === 'ArrowDown') {
      event.preventDefault();
      if (!this.isOpen) this.open();
      links[(index + 1) % links.length].focus();
    } else if (event.key === 'ArrowUp' && this.isOpen) {
      event.preventDefault();
      links[(index - 1 + links.length) % links.length].focus();
    } else if (event.key === 'Home' && this.isOpen && index > -1) {
      event.preventDefault();
      links[0].focus();
    } else if (event.key === 'End' && this.isOpen && index > -1) {
      event.preventDefault();
      links[links.length - 1].focus();
    }
  }
}

if (!customElements.get('header-more')) {
  customElements.define('header-more', HeaderMore);
}

// keyboard access for the help icon's hover modal
function initHeaderHelpKeyboard() {
  const wrapper = document.querySelector('.header--more .helper-modal-wrapper-inline-help');
  if (!wrapper) return;
  const modal = wrapper.querySelector('.modal-inline-help');
  const toggle = (show) => {
    modal.style.opacity = show ? '1' : '0';
    modal.style.pointerEvents = show ? 'auto' : 'none';
  };
  wrapper.addEventListener('focusin', () => toggle(true));
  wrapper.addEventListener('focusout', (e) => {
    if (!wrapper.contains(e.relatedTarget)) toggle(false);
  });
  wrapper.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      toggle(false);
      wrapper.querySelector('[data-open-help-modal]').focus();
    }
  });
}
initHeaderHelpKeyboard();
